export const inr = (n, opts = {}) => {
  const { compact = false, decimals = 0 } = opts;
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const num = Number(n);
  if (compact && Math.abs(num) >= 100000) {
    if (Math.abs(num) >= 10000000) return `₹${(num / 10000000).toFixed(2)}Cr`;
    return `₹${(num / 100000).toFixed(2)}L`;
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
};

export const pct = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "0%";
  return `${Number(n).toFixed(decimals)}%`;
};

export const num = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return new Intl.NumberFormat("en-IN").format(Number(n));
};

export const isoDate = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  return dt.toISOString().slice(0, 10);
};

export const startOfMonth = () => {
  const d = new Date();
  d.setDate(1);
  return isoDate(d);
};

export const todayISO = () => isoDate(new Date());
